export enum FbxEligibilityStatus {
  PREQUALIFIED = 'PREQUALIFIED',
  APPROVED = 'APPROVED',
}

interface FundboxPageContent {
  headline: string;
  subheadline: string;
  supportingLine?: string;
  ctaLabel?: string;
}

const PREQUALIFIED_HEADLINE_WITH_AMOUNT = (displayAmount: string): string =>
  `You're pre-qualified for up to a ${displayAmount}* term loan`;

const PREQUALIFIED_HEADLINE_WITHOUT_AMOUNT = "You're pre-qualified for a term loan";

export const getFundboxPageContent = (displayAmount?: string): FundboxPageContent => ({
  headline: displayAmount ? PREQUALIFIED_HEADLINE_WITH_AMOUNT(displayAmount) : PREQUALIFIED_HEADLINE_WITHOUT_AMOUNT,
  subheadline: "Access funds when you need them, whether you're scaling your business or managing expenses.",
  supportingLine: 'Apply in minutes, and if approved, get funds as soon as the next business day.',
  ctaLabel: 'Apply Now',
});
